import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import SVGIcon from '../SVGIcon'
import { Spinner } from 'reactstrap';

const DownloadButton = props =>{

const [reportTypeState, changeReportTypeState] = useState(null);
const [csvTypeState, changecsvType] = useState(null);

 const handelDownload = (csvType, fileName) => {

  changeReportTypeState(props.reportType);
  changecsvType(csvType)

  props.downloadAudience(csvType, props.reportType, fileName);

 }

 useEffect(() => {
   if(props.downloadingCSV === false){
    changeReportTypeState(null);
    changecsvType(null)
   }

}, [props.downloadingCSV]);


 return (
  <div
    className="WhereYourCustomersHaveBeenGraph_download-group"
    style={props.styleObj}
    onClick={()=> handelDownload(props.downloadParams.value.value, props.downloadParams.value.fileName)}
  >

    { ( props.downloadingCSV && reportTypeState === props.reportType && csvTypeState ===  props.downloadParams.value.value)
      ? ( <Spinner size="sm" color="dark" /> )
      : ( <SVGIcon icon="download" /> )
    }

  </div>
)}
;

DownloadButton.propTypes = {
  downloadingCSV: PropTypes.bool.isRequired,
  downloadAudience: PropTypes.func.isRequired,
  downloadParams: PropTypes.object.isRequired,
  reportType: PropTypes.string.isRequired,
  styleObj: PropTypes.object
};
export default DownloadButton;
